import { PoiAlertSpecificationInput } from './poi-alert-specification-input.model';
import { GeoFenceAlertSpecificationInput } from './geo-fence-alert-specification-input.model';


export class AlertSpecificationAddInput implements IAlertSpecificationAddInput {
    /** The auto-generated id of the alert master */
    alertId!: number;
    /** The auto-generated id of the alert group master */
    alertGroupId!: number;
    /** The value common must be 2000 character max */
    valueCommon!: string;
    /** The text must be 2000 character max */
    text!: string;
    /** The minimum value */
    min!: number;
    /** The maximum value */
    max!: number;
    /** The abnormal halt minute */
    commonMinute!: number;
    /** The POI type must be one of "ALL" ,"Selected" */
    poiType!: string;
    /** The geofence type must be one of "ALL" ,"Selected" */
    geofenceType!: string;
    /** The sms flag should br 0 or 1 */
    sms!: number;
    /** The email flag should br 0 or 1 */
    email!: number;
    /** The mobile no must be 13 character max */
    mobileNo!: string;
    /** The email address must be 320 character max */
    emailAddress!: string;
    /** The auto-generated id of the country master */
    countryId!: number;
    /** The vehicle type must be one of "On" ,"Off" or "Both" */
    commonRadioButtonValue!: string;
    /** Over speed */
    overSpeed!: number;
    /** Over speed Second */
    overSpeedSecond!: number;
    /** Zone Over speed */
    zoneOverSpeed!: number;
    /** Zone over speed second */
    zoneOverSpeedSecond!: number;
    /** The vehicle type must be one of "Single" ,"Multiple" */
    zoneOverSpeedAlertGeneration!: string;
    departFromPoiData!: PoiAlertSpecificationInput[];
    passedPoiData!: PoiAlertSpecificationInput[];
    reachedPoiData!: PoiAlertSpecificationInput[];
    enterGeofenceData!: GeoFenceAlertSpecificationInput[];
    outOfGeofenceData!: GeoFenceAlertSpecificationInput[];
    stayInZoneGeofenceData!: GeoFenceAlertSpecificationInput[];
    awayFromZoneGeofenceData!: GeoFenceAlertSpecificationInput[];
    overSpeedingGeofenceData!: GeoFenceAlertSpecificationInput[];

    constructor(data?: IAlertSpecificationAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.alertGroupId = _data["alertGroupId"];
            this.valueCommon = _data["valueCommon"];
            this.text = _data["text"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.commonMinute = _data["commonMinute"];
            this.poiType = _data["poiType"];
            this.geofenceType = _data["geofenceType"];
            this.sms = _data["sms"];
            this.email = _data["email"];
            this.mobileNo = _data["mobileNo"];
            this.emailAddress = _data["emailAddress"];
            this.countryId = _data["countryId"];
            this.commonRadioButtonValue = _data["commonRadioButtonValue"];
            this.overSpeed = _data["overSpeed"];
            this.overSpeedSecond = _data["overSpeedSecond"];
            this.zoneOverSpeed = _data["zoneOverSpeed"];
            this.zoneOverSpeedSecond = _data["zoneOverSpeedSecond"];
            this.zoneOverSpeedAlertGeneration = _data["zoneOverSpeedAlertGeneration"];
            if (Array.isArray(_data["departFromPoiData"])) {
                this.departFromPoiData = [] as any;
                for (let item of _data["departFromPoiData"])
                    this.departFromPoiData!.push(PoiAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["passedPoiData"])) {
                this.passedPoiData = [] as any;
                for (let item of _data["passedPoiData"])
                    this.passedPoiData!.push(PoiAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["reachedPoiData"])) {
                this.reachedPoiData = [] as any;
                for (let item of _data["reachedPoiData"])
                    this.reachedPoiData!.push(PoiAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["enterGeofenceData"])) {
                this.enterGeofenceData = [] as any;
                for (let item of _data["enterGeofenceData"])
                    this.enterGeofenceData!.push(GeoFenceAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["outOfGeofenceData"])) {
                this.outOfGeofenceData = [] as any;
                for (let item of _data["outOfGeofenceData"])
                    this.outOfGeofenceData!.push(GeoFenceAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["stayInZoneGeofenceData"])) {
                this.stayInZoneGeofenceData = [] as any;
                for (let item of _data["stayInZoneGeofenceData"])
                    this.stayInZoneGeofenceData!.push(GeoFenceAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["awayFromZoneGeofenceData"])) {
                this.awayFromZoneGeofenceData = [] as any;
                for (let item of _data["awayFromZoneGeofenceData"])
                    this.awayFromZoneGeofenceData!.push(GeoFenceAlertSpecificationInput.fromJS(item));
            }
            if (Array.isArray(_data["overSpeedingGeofenceData"])) {
                this.overSpeedingGeofenceData = [] as any;
                for (let item of _data["overSpeedingGeofenceData"])
                    this.overSpeedingGeofenceData!.push(GeoFenceAlertSpecificationInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertSpecificationAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["alertGroupId"] = this.alertGroupId;
        data["valueCommon"] = this.valueCommon;
        data["text"] = this.text;
        data["min"] = this.min;
        data["max"] = this.max;
        data["commonMinute"] = this.commonMinute;
        data["poiType"] = this.poiType;
        data["geofenceType"] = this.geofenceType;
        data["sms"] = this.sms;
        data["email"] = this.email;
        data["mobileNo"] = this.mobileNo;
        data["emailAddress"] = this.emailAddress;
        data["countryId"] = this.countryId;
        data["commonRadioButtonValue"] = this.commonRadioButtonValue;
        data["overSpeed"] = this.overSpeed;
        data["overSpeedSecond"] = this.overSpeedSecond;
        data["zoneOverSpeed"] = this.zoneOverSpeed;
        data["zoneOverSpeedSecond"] = this.zoneOverSpeedSecond;
        data["zoneOverSpeedAlertGeneration"] = this.zoneOverSpeedAlertGeneration;
        if (Array.isArray(this.departFromPoiData)) {
            data["departFromPoiData"] = [];
            for (let item of this.departFromPoiData)
                data["departFromPoiData"].push(item.toJSON());
        }
        if (Array.isArray(this.passedPoiData)) {
            data["passedPoiData"] = [];
            for (let item of this.passedPoiData)
                data["passedPoiData"].push(item.toJSON());
        }
        if (Array.isArray(this.reachedPoiData)) {
            data["reachedPoiData"] = [];
            for (let item of this.reachedPoiData)
                data["reachedPoiData"].push(item.toJSON());
        }
        if (Array.isArray(this.enterGeofenceData)) {
            data["enterGeofenceData"] = [];
            for (let item of this.enterGeofenceData)
                data["enterGeofenceData"].push(item.toJSON());
        }
        if (Array.isArray(this.outOfGeofenceData)) {
            data["outOfGeofenceData"] = [];
            for (let item of this.outOfGeofenceData)
                data["outOfGeofenceData"].push(item.toJSON());
        }
        if (Array.isArray(this.stayInZoneGeofenceData)) {
            data["stayInZoneGeofenceData"] = [];
            for (let item of this.stayInZoneGeofenceData)
                data["stayInZoneGeofenceData"].push(item.toJSON());
        }
        if (Array.isArray(this.awayFromZoneGeofenceData)) {
            data["awayFromZoneGeofenceData"] = [];
            for (let item of this.awayFromZoneGeofenceData)
                data["awayFromZoneGeofenceData"].push(item.toJSON());
        }
        if (Array.isArray(this.overSpeedingGeofenceData)) {
            data["overSpeedingGeofenceData"] = [];
            for (let item of this.overSpeedingGeofenceData)
                data["overSpeedingGeofenceData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAlertSpecificationAddInput {
    /** The auto-generated id of the alert master */
    alertId: number;
    /** The auto-generated id of the alert group master */
    alertGroupId: number;
    /** The value common must be 2000 character max */
    valueCommon: string;
    /** The text must be 2000 character max */
    text: string;
    /** The minimum value */
    min: number;
    /** The maximum value */
    max: number;
    /** The abnormal halt minute */
    commonMinute: number;
    /** The POI type must be one of "ALL" ,"Selected" */
    poiType: string;
    /** The geofence type must be one of "ALL" ,"Selected" */
    geofenceType: string;
    /** The sms flag should br 0 or 1 */
    sms: number;
    /** The email flag should br 0 or 1 */
    email: number;
    /** The mobile no must be 13 character max */
    mobileNo: string;
    /** The email address must be 320 character max */
    emailAddress: string;
    /** The auto-generated id of the country master */
    countryId: number;
    /** The vehicle type must be one of "On" ,"Off" or "Both" */
    commonRadioButtonValue: string;
    /** Over speed */
    overSpeed: number;
    /** Over speed Second */
    overSpeedSecond: number;
    /** Zone Over speed */
    zoneOverSpeed: number;
    /** Zone over speed second */
    zoneOverSpeedSecond: number;
    /** The vehicle type must be one of "Single" ,"Multiple" */
    zoneOverSpeedAlertGeneration: string;
    departFromPoiData: PoiAlertSpecificationInput[];
    passedPoiData: PoiAlertSpecificationInput[];
    reachedPoiData: PoiAlertSpecificationInput[];
    enterGeofenceData: GeoFenceAlertSpecificationInput[];
    outOfGeofenceData: GeoFenceAlertSpecificationInput[];
    stayInZoneGeofenceData: GeoFenceAlertSpecificationInput[];
    awayFromZoneGeofenceData: GeoFenceAlertSpecificationInput[];
    overSpeedingGeofenceData: GeoFenceAlertSpecificationInput[];
}

